/*
Complete The Look
*/

const stringToHTMLElement = (htmlString) => {
  const parser = new DOMParser();
  const parsedDocument = parser.parseFromString(htmlString, 'text/html');
  return parsedDocument.body;
};

/*
Image Zoom
*/

class ImageZoom extends HTMLElement {
  connectedCallback() {
    this.figure = this.querySelector('figure');
    if (this.figure) {
      this.figure.addEventListener('mousemove', (e) => {
        const zoomer = e.currentTarget;
        zoomer.style.opacity = 1;
        let offsetX = 0;
        let offsetY = 0;
        if (e.touches) {
          offsetX = e.touches[0].pageX;
          offsetY = e.touches[0].pageY;
        } else {
          offsetX = e.offsetX;
          offsetY = e.offsetY;
        }
        const x = (offsetX / zoomer.offsetWidth) * 100;
        const y = (offsetY / zoomer.offsetHeight) * 100;
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.backgroundSize = '400%';
      });
      this.figure.addEventListener('mouseleave', (e) => {
        const zoomer = e.currentTarget;
        zoomer.style.opacity = 0;
      });
    }
  }
}

customElements.define('image-zoom', ImageZoom);

/*
Select Variant
*/

class SelectVariant extends HTMLElement {
  constructor() {
    super();
    this.parameterName = 'variant';
    this.variantData = {};
    this.selectedCoverage = null;
    this.selectedSize = null;
    this.hasCoverage = false;
    this.optionIndexes = {};
  }

  connectedCallback() {
    this.buttonsSelectSize = this.querySelectorAll('.size-selector-button-js');
    this.buttonSelectOption = this.querySelectorAll('.option-selector-button-js');
    this.buttonsSelectCoverage = this.querySelectorAll('.coverage-selector-button-js');
    this.sizeQuantityMessage = this.querySelector('.size-quantity-message-js');
    this.coverageQuantityMessage = this.querySelector('.coverage-quantity-message-js');
    const root = this.closest('.grid') || document;
    this.addToCartButton = root.querySelector('.add-to-cart-js');
    this.variantAtcInput = root.querySelector('form input[name="id"]');
    this.giftcardPriceDisplay = document.querySelector('.giftcard-price-js');
    this.notifyMeButton = root.querySelector('#BIS_trigger');

    // Detect if coverage is present
    this.hasCoverage = this.buttonsSelectCoverage.length > 0;

    // Build optionIndexes map from data-option-names
    this.buildOptionIndexesFromAttribute();

    // Initialize variant data from the JSON
    this.initializeVariantData();

    // Get the current variant from URL or dataset
    const url = new URL(window.location.href);
    const currentVariantId = url.searchParams.get(this.parameterName) || this.dataset.selectedVariantId;

    // Find the current variant data
    const currentVariant = Object.values(this.variantData).find(
      (variant) => variant.id.toString() === currentVariantId
    );

    if (currentVariant) {
      // Set initial coverage and size using dynamic indexes
      const coverage =
        this.optionIndexes.coverage !== undefined ? currentVariant.options[this.optionIndexes.coverage] : null;
      const size = this.optionIndexes.size !== undefined ? currentVariant.options[this.optionIndexes.size] : null;
      this.selectedCoverage = coverage;
      this.selectedSize = size;
      // Update coverage/size availability first
      this.updateVariantAvailability(coverage);
      // Then set the initial button states
      this.setInitialButtonStates(currentVariant);
    }

    // Set up event listeners after initialization
    this.setupEventListeners();

    window.addEventListener('popstate', () => {
      this.renderStyle();
      this.getParameterValueAndRenderSelectedSize();
    });
  }

  buildOptionIndexesFromAttribute() {
    const optionNamesAttr = this.getAttribute('data-option-names');
    if (!optionNamesAttr) return;
    const optionNames = optionNamesAttr.split(',').map((name) => name.trim().toLowerCase());
    optionNames.forEach((name, idx) => {
      if (name.includes('coverage')) this.optionIndexes.coverage = idx;
      if (name.includes('size')) this.optionIndexes.size = idx;
      if (name.includes('color')) this.optionIndexes.color = idx;
    });
  }

  setupEventListeners() {
    // Set up coverage button listeners
    this.buttonsSelectCoverage.forEach((button) => {
      button.addEventListener('click', () => {
        this.buttonsSelectCoverage.forEach((btn) => (btn.style.textDecoration = 'none'));
        button.style.textDecoration = 'underline';
        const selectedCoverage = button.textContent.trim();
        const selectedSize = this.getCurrentSelectionsFromUI().selectedSize;
        const variant = this.getVariantForSelection(selectedCoverage, selectedSize);
        if (variant && this.variantAtcInput) {
          this.variantAtcInput.value = variant.id;
        }
        this.updateVariantAvailability(selectedCoverage);
        this.updateCoverageImages(selectedCoverage);
        // Update URL parameter
        if (variant) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variant.id);
          history.pushState({}, '', newUrl.toString());
        }
      });
    });

    // Set up size button listeners
    this.buttonsSelectSize.forEach((button) => {
      button.addEventListener('click', () => {
        this.buttonsSelectSize.forEach((btn) => (btn.style.textDecoration = 'none'));
        button.style.textDecoration = 'underline';
        const selectedSize = button.textContent.trim();
        const selectedCoverage = this.getCurrentSelectionsFromUI().selectedCoverage;
        const variant = this.getVariantForSelection(selectedCoverage, selectedSize);
        if (variant && this.variantAtcInput) {
          this.variantAtcInput.value = variant.id;
        }
        this.updateVariantAvailability(selectedCoverage);
        // Update URL parameter
        if (variant) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variant.id);
          history.pushState({}, '', newUrl.toString());
        }
      });
    });

    this.buttonSelectOption.forEach((button) => {
      button.addEventListener('click', () => {
        this.buttonSelectOption.forEach((btn) => (btn.style.textDecoration = 'none'));
        button.style.textDecoration = 'underline';
        let selectedVariantId = button.getAttribute('data-variant-id')
        selectedVariantId = parseInt(selectedVariantId)
        let giftCardPrice = button.getAttribute('data-price-giftcard')
        let giftCardPriceContainer = document.querySelector('.giftcard-price-js')
        let variant = Object.values(this.variantData).find((variant) => { 
          return variant.id == selectedVariantId
        })
        // Update URL parameter
        if (variant) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variant.id);
          history.pushState({}, '', newUrl.toString());
          let variantInput = document.querySelector('cart-add form input[name="id"]')
          variantInput ? variantInput.value = variant.id : null
          this.updateButtonStates(variant)
          giftCardPrice && giftCardPriceContainer ? giftCardPriceContainer.innerText = giftCardPrice : null
        }
      });
    });
  }

  updateButtonStyles(selectedButton, allButtons) {
    allButtons.forEach((button) => {
      button.style.textDecoration = button === selectedButton ? 'underline' : 'none';
    });
  }

  setInitialButtonStates(variant) {
    if (!variant) return;

    // Set coverage button state
    this.buttonsSelectCoverage.forEach((button) => {
      const buttonCoverage = button.textContent.trim();
      if (buttonCoverage === this.selectedCoverage) {
        button.style.textDecoration = 'underline';
        this.updateCoverageImages(buttonCoverage);
      }
    });

    // Set size button states
    this.buttonsSelectSize.forEach((button) => {
      const buttonSize = button.textContent.trim();
      if (buttonSize === this.selectedSize) {
        button.style.textDecoration = 'underline';
      }
    });

    // Set ATC/Notify Me button state
    this.updateButtonStates(variant);
  }

  updateButtonStates(variant) {
    if (!variant) return;

    if (variant.inventory === 0) {
      this.addToCartButton.setAttribute('disabled', '');
      this.addToCartButton.innerHTML = 'Out of stock';
      this.addToCartButton.style.opacity = '0.3';
      if (this.notifyMeButton) {
        this.notifyMeButton.classList.remove('!hidden');
      }
    } else {
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.innerHTML = 'Add to Cart';
      this.addToCartButton.style.opacity = '1';
      if (this.notifyMeButton) {
        this.notifyMeButton.classList.add('!hidden');
      }
    }
  }

  initializeVariantData() {
    try {
      // Get the variant data from the data-variants attribute
      const variantsJson = this.getAttribute('data-variants');
      if (!variantsJson) {
        console.error('No variant data found');
        return;
      }

      const variants = JSON.parse(variantsJson);

      // Build our variant data structure
      variants.forEach((variant) => {
        this.variantData[variant.id] = {
          id: variant.id,
          inventory: variant.inventory_quantity,
          options: [
            variant.option1, // Coverage
            variant.option2, // Size
            variant.option3, // Color
          ],
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          sku: variant.sku,
          available: variant.available,
        };
      });
    } catch (error) {
      console.error('Error initializing variant data:', error);
    }
  }

  getVariantForSelection(coverage, size) {
    const cIdx = this.optionIndexes.coverage;
    const sIdx = this.optionIndexes.size;
    if (cIdx !== undefined && sIdx !== undefined) {
      return Object.values(this.variantData).find((variant) => {
        return variant.options[cIdx] === coverage && variant.options[sIdx] === size;
      });
    } else if (sIdx !== undefined) {
      return Object.values(this.variantData).find((variant) => {
        return variant.options[sIdx] === size;
      });
    }
    return null;
  }

  getCurrentSelectionsFromUI() {
    // Get selected coverage
    let selectedCoverage = null;
    if (this.buttonsSelectCoverage && this.buttonsSelectCoverage.length > 0) {
      this.buttonsSelectCoverage.forEach((btn) => {
        if (btn.style.textDecoration === 'underline' || btn.classList.contains('active')) {
          selectedCoverage = btn.textContent.trim();
        }
      });
    }
    // Get selected size
    let selectedSize = null;
    if (this.buttonsSelectSize && this.buttonsSelectSize.length > 0) {
      this.buttonsSelectSize.forEach((btn) => {
        if (btn.style.textDecoration === 'underline' || btn.classList.contains('active')) {
          selectedSize = btn.textContent.trim();
        }
      });
    }
    return { selectedCoverage, selectedSize };
  }

  updateVariantAvailability(selectedCoverage) {
    const cIdx = this.optionIndexes.coverage;
    const sIdx = this.optionIndexes.size;
    // Get all unique sizes
    const sizes = Array.from(this.buttonsSelectSize).map((btn) => btn.textContent.trim());
    sizes.forEach((size) => {
      let isAvailable = false;
      let matchingVariant = null;
      Object.values(this.variantData).forEach((variant) => {
        if (cIdx !== undefined && sIdx !== undefined) {
          if (variant.options[cIdx] === selectedCoverage && variant.options[sIdx] === size) {
            matchingVariant = variant;
            if (variant.inventory > 0) {
              isAvailable = true;
            }
          }
        } else if (sIdx !== undefined) {
          if (variant.options[sIdx] === size) {
            matchingVariant = variant;
            if (variant.inventory > 0) {
              isAvailable = true;
            }
          }
        }
      });
      const sizeButton = Array.from(this.buttonsSelectSize).find((btn) => btn.textContent.trim() === size);
      if (sizeButton) {
        sizeButton.removeAttribute('disabled');
        if (!isAvailable) {
          if (!sizeButton.querySelector('s')) {
            sizeButton.innerHTML = `<s class=\"opacity-60\">${size}</s>`;
          }
        } else {
          const strikethrough = sizeButton.querySelector('s');
          if (strikethrough) {
            sizeButton.textContent = size;
          }
        }
      }
    });
    // After updating all size buttons, update ATC/Notify Me for the actual UI selection
    const selections = this.getCurrentSelectionsFromUI();
    const matchingVariant = this.getVariantForSelection(selections.selectedCoverage, selections.selectedSize);
    if (matchingVariant) {
      this.updateButtonStates(matchingVariant);
    } else {
      // No matching variant: disable ATC, show Notify Me
      if (this.addToCartButton) {
        this.addToCartButton.setAttribute('disabled', '');
        this.addToCartButton.innerHTML = 'Out of stock';
        this.addToCartButton.style.opacity = '0.3';
      }
      if (this.notifyMeButton) {
        this.notifyMeButton.classList.remove('!hidden');
      }
    }
  }

  renderStyle() {
    // Only clear underlines for the same type of option
    if (this.lastClickedButton) {
      if (this.lastClickedButton.classList.contains('coverage-selector-button-js')) {
        this.buttonsSelectCoverage.forEach((button) => {
          button.style.textDecoration = 'none';
        });
      } else if (this.lastClickedButton.classList.contains('size-selector-button-js')) {
        this.buttonsSelectSize.forEach((button) => {
          button.style.textDecoration = 'none';
        });
      }
    }
  }

  getParameterValueAndRenderSelectedSize() {
    const url = new URL(window.location.href);
    const myParam = url.searchParams.get(this.parameterName) || this.dataset.selectedVariantId;

    // Find the variant data for the selected variant
    const selectedVariant = Object.values(this.variantData).find((variant) => variant.id.toString() === myParam);

    if (selectedVariant) {
      const [coverage, size] = selectedVariant.options;
      this.selectedCoverage = coverage;
      this.selectedSize = size;

      // First update coverage availability and selection
      this.updateVariantAvailability(coverage);

      // Then set the button states
      this.setInitialButtonStates(selectedVariant);
    }
  }

  updateCoverageImages(selectedCoverage) {
    // First check if we have any coverage-tagged images at all
    const coverageImages = document.querySelectorAll('.coverage-image');

    // If no coverage-tagged images exist, don't run the visibility logic
    if (coverageImages.length === 0) {
      return;
    }

    // If we get here, we know we have coverage-tagged images
    const selectedCoverageImages = document.querySelectorAll(`.coverage-${selectedCoverage.toLowerCase()}`);

    // Get all containers (both desktop and mobile)
    const coverageContainers = [];
    const selectedCoverageContainers = [];

    // Find containers for coverage images (all possible container types)
    coverageImages.forEach((img) => {
      // Check for desktop container
      const desktopContainer = img.closest('image-zoom');
      if (desktopContainer) coverageContainers.push(desktopContainer);

      // Check for mobile carousel slide
      const mobileSlide = img.closest('.swiper-slide');
      if (mobileSlide) coverageContainers.push(mobileSlide);

      // Check for any other container that might be a parent
      const parentContainer = img.closest('[data-coverage-container]');
      if (parentContainer) coverageContainers.push(parentContainer);

      // If no specific container is found, use the image's immediate parent
      if (!desktopContainer && !mobileSlide && !parentContainer) {
        const immediateParent = img.parentElement;
        if (immediateParent) coverageContainers.push(immediateParent);
      }
    });

    // Find containers for selected coverage images
    selectedCoverageImages.forEach((img) => {
      // Check for desktop container
      const desktopContainer = img.closest('image-zoom');
      if (desktopContainer) selectedCoverageContainers.push(desktopContainer);

      // Check for mobile carousel slide
      const mobileSlide = img.closest('.swiper-slide');
      if (mobileSlide) selectedCoverageContainers.push(mobileSlide);

      // Check for any other container that might be a parent
      const parentContainer = img.closest('[data-coverage-container]');
      if (parentContainer) selectedCoverageContainers.push(parentContainer);

      // If no specific container is found, use the image's immediate parent
      if (!desktopContainer && !mobileSlide && !parentContainer) {
        const immediateParent = img.parentElement;
        if (immediateParent) selectedCoverageContainers.push(immediateParent);
      }
    });

    // Hide all coverage containers
    if (coverageContainers.length > 0) {
      coverageContainers.forEach((container) => {
        container.classList.add('hidden-coverage');
        // Also hide the container using display property as a fallback
        container.style.display = 'none';
      });
    }

    // Show selected coverage containers
    if (selectedCoverageContainers.length > 0) {
      selectedCoverageContainers.forEach((container) => {
        container.classList.remove('hidden-coverage');
        // Show the container using display property as a fallback
        container.style.display = '';
      });
    }

    // Update Swiper if it exists
    const swiperInstance = document.querySelector('.swiper')?.swiper;
    if (swiperInstance) {
      swiperInstance.update();
      swiperInstance.updateSlides();
      swiperInstance.updateProgress();
      swiperInstance.updateSlidesClasses();
    }
  }
}

customElements.define('select-variant', SelectVariant);

/*
Tab Collection
*/

class TabCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const menuScreens = this.querySelectorAll('.tab-container');

    const accountMenuItem = this.querySelectorAll('button.tab-menu');
    accountMenuItem.forEach((item, index) => {
      item.addEventListener('click', function () {
        accountMenuItem.forEach((item) => item.classList.remove('tab-menu-selected'));
        this.classList.add('tab-menu-selected');
        menuScreens.forEach((item) => item.classList.remove('active'));
        menuScreens[index].classList.add('active');
      });
    });

    const sizeChart = this.querySelector('.show-size-chart');
    if (sizeChart) {
      sizeChart.addEventListener('click', (e) => {
        const section = e.target.closest('section');
        const modal = section.querySelector('.modal');
        modal.classList.add('active');
      });
    }
  }
}

customElements.define('tab-collection', TabCollection);
